// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class TypingStatusChanged {
    chatId: string;
    isCustomerTyping: boolean;  
}